import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';

import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on LegalPage {
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          body {
            ... on RichTextBlock {
              id
              value
            }
          }
        }
      }
    }
  `,
  { Logo },
);
